<div class="box-wrapper row crm-scroll">
  <div [ngClass]="{ 'col-6': !baseService.isMobile, 'col-12': baseService.isMobile }">
    <div class="login-container gap-3">
      <div class="logo" (click)="baseService.toPreview()">
        <img class="logo-icon" src="/assets/svgs/logos/Logo_JE_128x420_primary.svg" alt="logo-of-JECRM" />
      </div>
      <div class="d-flex w-100 align-items-center justify-content-center flex-column gap-3">
        <h1 class="text-crm">{{ 'choose_company' | translate }}</h1>
        <div class="card-companies">
          <div class="prod-checbox" aria-labelledby="example-radio-group-label">
            @if (isLoader) {
              <div class="d-flex justify-content-center">
                <app-loader size="small"></app-loader>
              </div>
            } @else {
              @for (company of companies; track company) {
                <div class="radio-toolbar" (click)="onSelectCompany(company.subdomain)">
                  <span class="company-names">{{ company.name }}</span>
                  @if (company.role === 'OWNER') {
                    <span class="fs-sm">{{ 'owner' | translate }}</span>
                  }
                  @if (company.role === 'MANAGER') {
                    <span class="fs-sm">{{ 'manager' | translate }}</span>
                  }
                  <!--              <mat-divider class="company-names"></mat-divider>-->
                  <!--              <span class="company-names">-&#45;&#45;</span>-->
                  <!--              <span class="link-on">{{company.subdomain}}.{{environment.web_url}}</span>-->
                </div>
              }
              @if (!companies?.length) {
                <button class="app-button" (click)="createCompany()">
                  <div class="plus">
                    <app-icon>add</app-icon>
                    <span class="create-company">{{ 'create_company' | translate }}</span>
                  </div>
                </button>
              }
            }
          </div>
        </div>
      </div>

      <div class="buttons-login">
        <button class="but exit" (click)="logout()">{{ 'exit' | translate }}</button>
      </div>
    </div>
  </div>
  @if (!baseService.isMobile) {
    <div class="col-6">
      <p-carousel
        [value]="images"
        [showNavigators]="false"
        [showIndicators]="false"
        [circular]="false"
        [autoplayInterval]="3000"
      >
        <ng-template let-image #item>
          <div class="slide">
            <img [src]="image.img" alt="Slide-Image" />
            <div class="slide-text">
              <h2>{{ image.heading | translate }}</h2>
              <p>{{ image.description | translate }}</p>
            </div>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  }
</div>
